import { Route, Switch } from 'react-router-dom'
import NotFoundPage from '../404/NotFoundPage'
import DefaultAdminScreen from '../default/DefaultAdminScreen'
import { ROUTER_PATH } from './metaData'
import ProfileScreen from '../profile'
import AccountScreen from '../account'
const UserRouters = (props: any) => {
   return (
      <Switch>
         <Route exact path={`/`} component={DefaultAdminScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProfileScreen}`} component={ProfileScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountScreen}`} component={AccountScreen} />
         <Route path="*" component={NotFoundPage} />
      </Switch>
   )
}

export default UserRouters
